import React from "react";
import { Table, Divider, Input, Button, Tooltip } from "antd";
import {
  EditOutlined,
  SearchOutlined,
  PlusCircleOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import PropTypes from "prop-types";
import { StatusSwitch } from "../Common/StatusSwitch";
import {
  defaultSort,
  getTablePagesize,
  setTablePageSize,
} from "../../Constants/Utilities";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  ServiceEntitlementActions,
  StatusFilters,
  TablePages,
  TablePageSizes,
} from "../../Constants/Constants";
import { BreadCrumbs } from "../Common/BreadCrumbs";

class ListServiceEntitlement extends React.Component {
  constructor(props) {
    super(props);
    console.log("ListServiceEntitlement props", props);
    this.state = {
      serviceEntitlementData: props.serviceEntitlementData,
    };
  }

  componentDidUpdate(prevProps) {
    const { serviceEntitlementData } = this.props;
    if (prevProps.serviceEntitlementData !== serviceEntitlementData) {
      this.setState({ serviceEntitlementData });
    }
  }

  getColumns = () => [
    {
      title: "Entitlement Name",
      dataIndex: "entitlementName",
      sorter: (a, b) => defaultSort(a.entitlementName, b.entitlementName),
      defaultSortOrder: "ascend",
      width: "30%",
      render: (value, record) => (
        <Button
          type="link"
          onClick={this.props.onActionClick(
            ServiceEntitlementActions.view,
            record
          )}
        >
          {value}
        </Button>
      ),
    },
    {
      title: "Device Model Number",
      dataIndex: "modelNumber",
      sorter: (a, b) => defaultSort(a.modelNumber, b.modelNumber),
      width: "20%",
    },
    {
      title: "Service Tier Name",
      dataIndex: "serviceTierName",
      sorter: (a, b) => defaultSort(a.serviceTierName, b.serviceTierName),
      width: "30%",
    },
    {
      title: "Active",
      dataIndex: "status",
      align: "center",
      width: "10%",
      filters: StatusFilters,
      onFilter: (value, record) => record.status === value,
      render: StatusSwitch(this.props.onStatusChange),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      align: "center",
      width: "10%",
      render: (_, record) => (
        <div className="entity-list-actions">
          <Tooltip title="View Entitlement">
            <FileTextOutlined
              className="entity-action"
              onClick={this.props.onActionClick(
                ServiceEntitlementActions.view,
                record
              )}
            />
          </Tooltip>
          <Tooltip title="Edit Entitlement">
            <EditOutlined
              onClick={this.props.onActionClick(
                ServiceEntitlementActions.edit,
                record
              )}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  onSerchTextChange = (e) => {
    const text = e.target.value;
    const { serviceEntitlementData } = this.props;
    if (!!text) {
      const filteredData = serviceEntitlementData.filter((item) =>
        item.entitlementName?.toLowerCase().includes(text.toLowerCase())
      );
      this.setState({ serviceEntitlementData: filteredData });
      return;
    }
    this.setState({ serviceEntitlementData });
  };

  render() {
    const { serviceEntitlementData } = this.state;
    const {
      onActionClick,
      onParentActionClick,
      serviceProviderRecord,
      serviceEntitlementDataLoading,
      parentBread,
    } = this.props;

    return (
      <div className="entity-list-container">
        <div className="page-header-container">
          <BreadCrumbs
            headers={parentBread}
            onParentActionClick={onParentActionClick(null, null)}
          />
        </div>
        <Divider className="divider" />
        <div className="page-parent-title-container">
          <label>Service Provider: {serviceProviderRecord.name}</label>
        </div>
        <div className="search-add-container">
          <div className="search-container">
            <span className="search-label">Search:</span>
            <Input
              allowClear
              className="search-input"
              placeholder="Enter Entitlement Name"
              onChange={this.onSerchTextChange}
              suffix={<SearchOutlined style={{ fontSize: 16 }} />}
            />
          </div>
          <div className="add-container">
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={onActionClick(ServiceEntitlementActions.add, null)}
            >
              Add Service Entitlement
            </Button>
          </div>
        </div>
        <Table
          bordered
          size="small"
          columns={this.getColumns()}
          className="entity-table"
          loading={
            serviceEntitlementDataLoading && {
              tip: "Fetching Service Entitlement list...",
            }
          }
          dataSource={serviceEntitlementData}
          pagination={{
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            defaultPageSize: getTablePagesize(
              TablePages.listServiceEntitlement
            ),
            pageSizeOptions: TablePageSizes,
            onChange: (_, pageSize) =>
              setTablePageSize(TablePages.listServiceEntitlement, pageSize),
          }}
        />
      </div>
    );
  }
}

ListServiceEntitlement.propTypes = {
  serviceProviderRecord: PropTypes.object,
  serviceEntitlementData: PropTypes.array,
  serviceEntitlementDataLoading: PropTypes.bool,
  onActionClick: PropTypes.func,
  onParentActionClick: PropTypes.func,
  onStatusChange: PropTypes.func,
  parentBread: PropTypes.array,

  serviceEntitlementApi: PropTypes.object,
};

const mapStateToProps = (state) => ({
  serviceEntitlementApi: state.apis.serviceEntitlementApi,
});
const connectedListServiceEntitlement = connect(mapStateToProps)(
  ListServiceEntitlement
);
export default withRouter(connectedListServiceEntitlement);
